import React, {memo} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

function Loading({opRef, snapshotMap}) {
    return(
        <div style={snapshotMap ? loadingCSSSnapshotMap : loadingCSS} ref={opRef && opRef}>
            <FontAwesomeIcon icon={faSpinner} pulse aria-label="Loading" />
        </div>
    );
}

export default memo(Loading);

let loadingCSS = {
    color: "#A9A9A9",
    fontSize: "50px",
    height: "50px",
    textAlign: "center",
    position: "absolute",
    top: "50%",
    left: "45%",
    marginTop: "-40px"
};

let loadingCSSSnapshotMap = {
    color: "#A9A9A9",
    fontSize: "50px",
    height: "50px",
    textAlign: "center",
    position: "absolute",
    top: "calc(80vh * 0.5)",
    left: "45%",
}